<table class="record-table" *ngIf="indexArr">
  <thead>
    <tr>
      <th class="record-header">出社</th>
      <th class="record-header">退社</th>
      <th class="record-header">外出</th>
      <th class="record-header">戻り</th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let i of indexArr">
      <tr>
        <td [ngClass]="{'normal-stamp': !arriveStamps[i]?.ejectFlag && !arriveStamps[i]?.isNew ,'ejected-stamp': arriveStamps[i]?.ejectFlag, 'additional-stamp': arriveStamps[i]?.isNew }">
          {{ arriveStamps[i]?.stampStr }}
        </td>
        <td [ngClass]="{'normal-stamp': !leaveStamps[i]?.ejectFlag && !leaveStamps[i]?.isNew ,'ejected-stamp': leaveStamps[i]?.ejectFlag, 'additional-stamp': leaveStamps[i]?.isNew }">
          {{ leaveStamps[i]?.stampStr }}
        </td>
        <td [ngClass]="{'normal-stamp': !temporaryLeaveStamps[i]?.ejectFlag && !temporaryLeaveStamps[i]?.isNew ,'ejected-stamp': temporaryLeaveStamps[i]?.ejectFlag, 'additional-stamp': temporaryLeaveStamps[i]?.isNew }">
          {{ temporaryLeaveStamps[i]?.stampStr }}
        </td>
        <td [ngClass]="{'normal-stamp': !reenterStamps[i]?.ejectFlag && !reenterStamps[i]?.isNew ,'ejected-stamp': reenterStamps[i]?.ejectFlag, 'additional-stamp': reenterStamps[i]?.isNew }">
          {{ reenterStamps[i]?.stampStr }}
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>
